import { render } from "./cheque.vue?vue&type=template&id=34b9f4fe&scoped=true"
import script from "./cheque.vue?vue&type=script&lang=js"
export * from "./cheque.vue?vue&type=script&lang=js"

import "./cheque.vue?vue&type=style&index=0&id=34b9f4fe&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34b9f4fe"]])

export default __exports__